import React, { useContext, useCallback } from 'react';

import { View, ThemeProvider } from '@fairygodboss/ui';

import { JobContext } from '../../../../../contexts/ContextCreator';
import { determineJobLikedStatus } from '../../SingleJobTemplateV2/SingleJobTemplateV2';
import { ApplyButtonGroup } from '../../SingleJobTemplateV2/ApplyButtonGroup';

export const ButtonFooterV2 = ({
    handleCompanyApplyClick,
    showDirectApply,
    handleQuickApplyClick,
    visible,
    jobDetails,
    hasCookie,
    cookieBannerHeight,
    onJobSaveClick,
    userLiked,
    ...others
}) => {
    const { slug } = jobDetails;
    const jobContext = useContext(JobContext);
    const { toggleJobLike, content } = jobContext;

    const isSaved = userLiked || determineJobLikedStatus(slug, content);
    const handleSaveClick = useCallback(() => {
        if (onJobSaveClick) {
            onJobSaveClick({ userLiked, hash: slug, posistion: 'sticky' });
            return;
        }
        toggleJobLike(slug);
    }, [toggleJobLike, slug, onJobSaveClick, userLiked]);

    const bottomPosition = hasCookie ? 0 : `${cookieBannerHeight}px`;

    if (!visible) {
        return null;
    }

    return (
        <ThemeProvider>
            <View
                backgroundColor="white"
                position="fixed"
                p="16px"
                left={0}
                right={0}
                bottom={{ _: bottomPosition }}
                width="100%"
                display={{ _: 'flex', md: 'none' }}
                justifyContent={{ _: 'center', md: undefined }}
                zIndex={1}
                boxShadow="0 -2px 12px 0 rgba(0, 0, 0, 0.32)"
                {...others}
            >
                <ApplyButtonGroup
                    handleSaveClick={handleSaveClick}
                    isSaved={isSaved}
                    showDirectApply={showDirectApply}
                    handleQuickApplyClick={handleQuickApplyClick}
                    handleCompanyApplyClick={handleCompanyApplyClick}
                    position="sticky-nav"
                />
            </View>
        </ThemeProvider>
    );
};

export default ButtonFooterV2;
